package top.wcpe.allincore.dsl.ir.codec

/**
 * [IrByteReader] 的纯 Kotlin 实现：读取一个 [ByteArray]，全平台可用（JVM / JS）。
 *
 * 字节序与 Netty `ByteBuf` 完全一致——**大端（big-endian）**、无符号读返回加宽类型，
 * 保证与 `ByteBufIrReader` 解码行为逐字节一致。
 *
 * 非线程安全：单次解码在单线程内完成。
 */
class ByteArrayIrReader(private val data: ByteArray) : IrByteReader {

    private var pos: Int = 0

    override fun readByte(): Byte = data[pos++]

    override fun readUnsignedByte(): Int = data[pos++].toInt() and 0xFF

    override fun readUnsignedShort(): Int {
        val hi = data[pos++].toInt() and 0xFF
        val lo = data[pos++].toInt() and 0xFF
        return (hi shl 8) or lo
    }

    override fun readInt(): Int {
        val b0 = data[pos++].toInt() and 0xFF
        val b1 = data[pos++].toInt() and 0xFF
        val b2 = data[pos++].toInt() and 0xFF
        val b3 = data[pos++].toInt() and 0xFF
        return (b0 shl 24) or (b1 shl 16) or (b2 shl 8) or b3
    }

    override fun readUnsignedInt(): Long = readInt().toLong() and 0xFFFFFFFFL

    override fun readDouble(): Double {
        var bits = 0L
        for (i in 0 until 8) {
            bits = (bits shl 8) or (data[pos++].toLong() and 0xFF)
        }
        return Double.fromBits(bits)
    }

    override fun readBytes(dest: ByteArray) {
        data.copyInto(dest, 0, pos, pos + dest.size)
        pos += dest.size
    }

    override fun readableBytes(): Int = data.size - pos

    override fun isReadable(): Boolean = pos < data.size
}
